import { Dropdown, Form, Select } from "antd";
import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  ResponsiveContainer,
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import { useDispatch, useSelector } from "react-redux";


const YieldCropGraph = () => {
  const [countyId, setCountyId] = useState(null);
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const [form] = Form.useForm();

 const url = "api/v2/dashboard/getAllDashboardData";
  const { loading, data } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
  }));



  return (
    <div className="p-[1.25rem] rounded-[.75rem] bg-white w-full h-full">
      <div className="flex items-center justify-between w-full mb-[1rem]">
        <div className="text-[#424242] text-[.75rem] font-[500] font-interSans">
          Total Yield per Major Crop (Kg)
        </div> 
      </div>

      <ResponsiveContainer width="100%" height={300}>
        <ComposedChart data={data?.productionPerCrop} margin={{ left: 0, bottom: 20 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="name" />
          <YAxis tickFormatter={(value) => `${value / 1000}k`} />
          <Tooltip />

          {/* Filled teal bars */}
          <Bar
            dataKey="value"
            stackId="a"
            barSize={15}
            fill="#2CA6A4"
            radius={[4, 4, 0, 0]}
          />

          {/* Grey background bars */}
          <Bar
            dataKey={(d) => d.max_value - d.value}
            stackId="a"
            barSize={15}
            fill="#E6E6F0"
          /> 
          
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default YieldCropGraph;
